import React from 'react';
import Select from 'react-select';
import { Alert, AlertVariant } from '../../../../components/Alert';
import styles from './AddRiskyIdForm.module.css';

interface EmployerOption {
  id: number;
  company_name: string;
}

interface SelectOption {
  value: number;
  label: string;
}

interface CompromisedEmployerFormFieldsProps {
  reason: string;
  onReasonChange: (value: string) => void;
  active?: boolean;
  onActiveChange?: (value: boolean) => void;
  employers?: EmployerOption[];
  selectedEmployerId?: number | null;
  onEmployerChange?: (id: number | null) => void;
  isEmployerDisabled?: boolean;
  showAlert?: boolean;
}

const CompromisedEmployerFormFields: React.FC<CompromisedEmployerFormFieldsProps> = ({
  reason,
  onReasonChange,
  active,
  onActiveChange,
  employers = [],
  selectedEmployerId = null,
  onEmployerChange,
  isEmployerDisabled = false,
  showAlert = false
}) => {
  const options: SelectOption[] = employers.map((emp) => ({
    value: emp.id,
    label: emp.company_name
  }));

  const selectedOption = options.find((o) => o.value === selectedEmployerId) ?? null;

  return (
    <>
      {onEmployerChange && (
        <div className="mb-3">
          <label htmlFor="employer" className="form-label"> {/* skipcq: JS-0752 */}
            Employer <span className="text-danger">*</span>
          </label>
          <Select
            inputId="employer"
            options={options}
            value={selectedOption}
            onChange={(option) => onEmployerChange(option ? option.value : null)}
            placeholder="Search employers..."
            isDisabled={isEmployerDisabled}
            isClearable
            noOptionsMessage={() => 'No employers found'}
          />
        </div>
      )}

      <div className="mb-3">
        <label htmlFor="is_compromised_reason" className="form-label"> {/* skipcq: JS-0752 */}
          Reason
        </label>
        <textarea
          id="is_compromised_reason"
          name="is_compromised_reason"
          className={`form-control ${styles.formTextarea}`}
          rows={4}
          value={reason}
          onChange={(e) => onReasonChange(e.target.value)}
          maxLength={255}
          placeholder="Enter reason for flagging this employer"
          required={false}
        />
        <small className="form-text text-muted">
          {reason.length}/255 characters
        </small>
      </div>

      {onActiveChange !== undefined && (
        <div className="mb-3">
          <label htmlFor="active" className="form-label"> {/* skipcq: JS-0752 */}
            Active
          </label>
          <div className={`${styles.activeToggle} ${styles.switchContainer}`}>
            <input
              className={styles.switchInput}
              type="checkbox"
              id="active"
              checked={active}
              onChange={(e) => onActiveChange(e.target.checked)}
              role="switch"
              aria-checked={active}
              aria-label="Toggle active status"
            />
            <label
              aria-hidden="true"
              htmlFor="active"
              className={`${styles.toggleSwitch} ${active ? styles.active : ''}`}>{/* skipcq: JS-0752 */}
              <div className={`${styles.toggleSlider} ${active ? styles.active : ''}`} />
            </label>
          </div>
          <small className="form-text text-muted">
            When inactive, this employer will not be treated as compromised
          </small>
        </div>
      )}

      {showAlert && (
        <Alert variant={AlertVariant.Pink}>
          Existing employees of this employer will not be able to update their mobile numbers.
        </Alert>
      )}
    </>
  );
};

export default CompromisedEmployerFormFields;
